import { render, staticRenderFns } from "./CallcentreMemberList.vue?vue&type=template&id=6c950c8e&"
import script from "./CallcentreMemberList.vue?vue&type=script&lang=js&"
export * from "./CallcentreMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports